'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _ProductTierOrders = require('self-service-api/constants/ProductTierOrders');

var _ProductTierOrders2 = _interopRequireDefault(_ProductTierOrders);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// These legacy sales pro products have the same parcel name
// so we need to explicitly check ownedByHub to know which
// legacy sku the hub has
var SALES_PRO_LEGACY_PRODUCTS = [_MerchandiseIds.PRODUCT_SALES_PRO_LEGACY, _MerchandiseIds.PRODUCT_SALES_PRO_BUSINESS_USER];

// Services products don't have parcels associated with them,
// so we need to explicitly check ownedByHub
var SERVICES_PRODUCTS = [_MerchandiseIds.SERVICE_CRM_SALES_STARTER_KIT, _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING, _MerchandiseIds.SERVICE_SALES_ENTERPRISE_ONBOARDING, _MerchandiseIds.SERVICE_MARKETING_BASIC_ONBOARDING, _MerchandiseIds.SERVICE_MARKETING_PROFESSIONAL_ONBOARDING, _MerchandiseIds.SERVICE_MARKETING_ENTERPRISE_ONBOARDING, _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING, _MerchandiseIds.SERVICE_SERVICE_ENTERPRISE_ONBOARDING, _MerchandiseIds.SERVICE_QUICK_START_CONSULTATION];

// This describes merch where you'll always have the free tier parcel
// even if you have a higher paid product
var FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS = [_MerchandiseIds.PRODUCT_MARKETING_FREE, _MerchandiseIds.PRODUCT_SALES_FREE, _MerchandiseIds.PRODUCT_SERVICE_FREE];

var hasSomeParcel = function hasSomeParcel(userParcels, productParcels) {
  return userParcels.some(function (userParcel) {
    var hasParcel = productParcels.some(function (productParcel) {
      var hasSameParcelName = productParcel.parcelName === userParcel.parcelName;

      var userParcelVersion = userParcel.parcelVersion ? userParcel.parcelVersion.version : null;

      var hasSameParcelVersion = productParcel.parcelVersion === userParcelVersion;

      // non-MAIN parcel version types don't qualify as product ownership
      var hasParcelVersionMain = userParcel.parcelVersion ? userParcel.parcelVersion.type === 'MAIN' : false;

      return hasSameParcelName && hasSameParcelVersion && hasParcelVersionMain;
    });

    return hasParcel;
  });
};

var _hasRightParcels = function _hasRightParcels(products, parcels, merchandiseId) {
  if (parcels.size === 0) return false;

  var product = products[merchandiseId];

  var additionalParcelsToCheck = _ImmutableMerchandiseIdMap2.default[merchandiseId].parcels;

  // Parcel on the product may be redundant with additionalParcelsToCheck
  var parcelsForMerch = [];
  if (product) {
    parcelsForMerch.push({
      parcelName: product.parcelName,
      parcelVersion: product.parcelVersion
    });
  }
  if (additionalParcelsToCheck) {
    parcelsForMerch.push.apply(parcelsForMerch, _toConsumableArray(additionalParcelsToCheck));
  }
  // Identity keeps around old parcels on a delay, so to accurately tell
  // what a portal owns, we need to make sure there isn't an expiresAt
  // prop on the parcel.
  var nonExpiringParcels = parcels.filter(function (parcel) {
    return !parcel.expiresAt;
  });
  return hasSomeParcel(nonExpiringParcels, parcelsForMerch);
};

var _isOwnedByHub = function _isOwnedByHub(merchandiseId, products) {
  var product = products[merchandiseId];
  if (!product) return false;
  return product.ownedByHub;
};

var isProductOwnedAdapter = function isProductOwnedAdapter(productData, parcels, merchandiseId) {
  var products = productData.products;


  if (SALES_PRO_LEGACY_PRODUCTS.indexOf(merchandiseId) !== -1 || SERVICES_PRODUCTS.indexOf(merchandiseId) !== -1) {
    return _isOwnedByHub(merchandiseId, products);
  }

  var hasRightParcels = _hasRightParcels(products, parcels, merchandiseId);

  if (FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS.indexOf(merchandiseId) === -1 || hasRightParcels === false) {
    return hasRightParcels;
  }

  // In the case of FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS
  // we want to return false if any of the higher merchandise
  // return true for _hasRightParcels
  var tieredProductsGroup = _ProductTierOrders2.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];
  var higherMerch = tieredProductsGroup.slice(1, tieredProductsGroup.length);
  return !higherMerch.some(function (higherMerchId) {
    return _hasRightParcels(products, parcels, higherMerchId);
  });
};

exports.default = isProductOwnedAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/isProductOwnedAdapter.js
// module id = 158
// module chunks = 3 4 5